import styled from 'styled-components'

export const Mover = styled.div`
    cursor: grab;
    height: 100%;
    touch-action: none;
    user-select: none;
    -webkit-touch-callout: none;
    width: 100%;

    &:active {
        cursor: grabbing;
    }
`
